import { useEffect, useState } from "react";
import { FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { ImportButton } from "../CommonComponents/InputBox";
import { CommonApiData } from "../../EnvConfig/env_config";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile } from "../CommonComponents/ExportData";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
const ImportProgressUpdate = ({ menuText }) => {

    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const dispatch = useDispatch();
    //Start Bulk Upload
    const Data = CommonApiData()
    let IData = {
        ...Data,
        "progressID": "",
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ProgressUpdate.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ProgressUpdateError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
        let a = document.querySelectorAll('.bulk-upload');
        if (a.length > 0) {
            a[0].childNodes[2].innerHTML = data.FileName;
        }
    };
  
    const handleBulk = async () => {
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("ProgressDate", "ProgressTime", "AwbNo","Exception")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Operation/ProgressUpdate', ImportData, IData, null)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    //End Bulk Upload
   
    useEffect(() => {
        document.title = 'Import Progress Update'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{menuText ? menuText : FindTranslatedKey('Import Progress Update')}</h6>

                </div>
                <div className='card-body row'>

                    <div className='d-flex col-md-6 col-lg-4 h-25'>
                        <ImportButton
                            handleBulk={handleBulk}
                            BulkSubmit={(e) => BulkSubmit(e)}
                            downloadFormat={DownloadFormat}
                            ErrorData={ErrorData}
                            Status={Status}
                            HeaderFormat="PayMode, Active"
                            fileName={Name}
                        >
                        </ImportButton>
                    </div>

                </div>
            </div>


        </>
    )
}

export default ImportProgressUpdate;